import React from 'react'

const PagesPrevilage = () => {
  return (
    <div>PagesPrevilage</div>
  )
}

export default PagesPrevilage